const getLaborTicketModalOpen = (state) => {
  return state?.laborTicketModalOpen;
};

export { getLaborTicketModalOpen };
